"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withQueryParams = void 0;
const react_1 = __importDefault(require("react"));
const react_display_name_1 = __importDefault(require("react-display-name"));
const queryparams_1 = require("./queryparams");
/**
 * A HoC which augments the props with the queryParams from the
 * react-router-dom's `Location.search` string as an actual object.
 *
 * Requires defaultQueryParameters to fill in the blanks when the
 * query parameters are not in the url. This way you are guaranteed
 * to always have values for your query parameters.
 *
 * It also uses the defaultQueryParameters to convert the query
 * parameters (which all come out as strings) to the type of
 * the defaultQueryParameter.
 *
 * @example
 * withQueryParams(App, { page: 1, search: '', showAll: true })
 *
 * This will create an App component which has a prop queryParams which
 * is an object which contains page a number, search a string, and
 * showAll a boolean.
 *
 * @example
 * withQueryParams(App, { show: ['medium'] })
 *
 * Can also support arrays and convert to actual types as well.
 *
 * @param {React.ComponentType<P>} Component The react component which you want to encapsulate with the withQueryParams HoC
 * @param {Object} defaultQueryParams The default query parameters which will be used to fill in any blanks in the query params
 * @returns Component wrapped with HoC which provides the query params as a prop.
 */
const withQueryParams = (Component, defaultQueryParams) => {
    class WithQueryParams extends react_1.default.Component {
        render() {
            const _a = this.props, { location } = _a, props = __rest(_a, ["location"]);
            // @ts-expect-error accept that there might be a displayName;
            const debugName = WithQueryParams.displayName;
            const typedQueryParams = (0, queryparams_1.queryParamsFromLocation)({
                location,
                defaultQueryParams,
                debugName
            });
            return react_1.default.createElement(Component, Object.assign({ queryParams: typedQueryParams }, props));
        }
    }
    // @ts-expect-error accept that there might be a displayName;
    WithQueryParams.displayName = `WithQueryParams(${(0, react_display_name_1.default)(Component)})`;
    return WithQueryParams;
};
exports.withQueryParams = withQueryParams;
